import React, { useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export const ImageWithLoading = _ref => {
  let {
    src,
    sizeClass = "size-[400px]",
    isLoading,
    style,
    onAspectRatioChange,
    ...props
  } = _ref;
  const [aspectRatio, setAspectRatio] = useState("2/1");
  const loadingClass = isLoading ? "animate-pulse bg-gray-100" : "";
  const blurClass = !src ? "blur-[40px]" : "";
  useEffect(() => {
    if (src) {
      const img = new Image();
      img.onload = () => {
        console.log("img.width", img.width);
        console.log("img.height", img.height);
        const ratio = `${img.width}/${img.height}`;
        console.log("ratio", ratio);
        setAspectRatio(ratio);
        onAspectRatioChange === null || onAspectRatioChange === void 0 || onAspectRatioChange(ratio);
      };
      img.src = src;
    }
  }, [src, onAspectRatioChange]);
  return /*#__PURE__*/_jsx("div", {
    ...props,
    className: `bg-cover bg-center bg-no-repeat bg-transparent ${sizeClass} ${blurClass} ${loadingClass}`,
    style: {
      backgroundImage: `url("${src || ""}")`,
      aspectRatio,
      objectFit: "contain",
      height: "300px",
      ...style
    }
  });
};